import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const messageDefaultVariants = {
  "variant": "default",
  "kind": "default"
}
const messageCompoundVariants = []

const messageSlotNames = [
  [
    "root",
    "Message__root"
  ],
  [
    "wrapper",
    "Message__wrapper"
  ],
  [
    "title",
    "Message__title"
  ],
  [
    "cta",
    "Message__cta"
  ],
  [
    "actionGroup",
    "Message__actionGroup"
  ],
  [
    "iconWrapper",
    "Message__iconWrapper"
  ]
]
const messageSlotFns = /* @__PURE__ */ messageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, messageDefaultVariants, getSlotCompoundVariant(messageCompoundVariants, slotName))])

const messageFn = memo((props = {}) => {
  return Object.fromEntries(messageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const messageVariantKeys = [
  "variant",
  "kind"
]
const getVariantProps = (variants) => ({ ...messageDefaultVariants, ...compact(variants) })

export const message = /* @__PURE__ */ Object.assign(messageFn, {
  __recipe__: false,
  __name__: 'message',
  raw: (props) => props,
  variantKeys: messageVariantKeys,
  variantMap: {
  "variant": [
    "default",
    "subtle",
    "contrast",
    "success",
    "warning",
    "danger"
  ],
  "kind": [
    "default",
    "inline"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, messageVariantKeys)
  },
  getVariantProps
})